module.exports = __webpack_public_path__ + "static/media/fireaul.aaa07e6a.png";